{
	"title": "Осигуряване на отчетност чрез внедряване на въглеродна банка",
	"description": "Heidelberg Materials е предприела задълбочени мерки, за да гарантира достоверността на намаленията на въглеродните емисии, генерирани от нашия циментов завод с CCS. За да предотвратим всякаква възможност за двойно отчитане, внедрихме сигурна виртуална въглеродна банка върху публичен разпределен регистър.",
	"traceabilityTitle": "Проследимост на намаленията на въглеродните емисии"
}
